import { DocumentUploadAccountTypes } from '@interfaces/models/doc-upload-types';
import { IRATrustTypes } from '@interfaces/models/ira-trust-types';

import {
  ViadocExpectableLabel,
  ViadocUploadStep,
} from '../../../../../interfaces/models/viadoc-types';

export interface ExpectedLabelInputs {
  uploadStep: ViadocUploadStep;
  isDeathVerified: boolean;
  isExecutor: boolean;
  isIRAExecutor: boolean;
  isTrustee: boolean;
  isTrustToTrustFlow: boolean;
  isDivorceFlow: boolean;
  isMultiInheritanceFlow: boolean;
  isMultiInheritanceEstateToggleOn: boolean;
  typeOfTrust?: IRATrustTypes;
  selectedAccountTypes: string[];
}

const ACCOUNT_TYPES_NEEDING_LEGAL_PROSE: readonly string[] = [
  DocumentUploadAccountTypes.ESTATE,
  DocumentUploadAccountTypes.TRUST_UNDER_AGREEMENT,
  DocumentUploadAccountTypes.TRUST_UNDER_WILL,
];

function resolveMultiInheritanceEstateLabels(inputs: ExpectedLabelInputs): ViadocExpectableLabel[] {
  const needsDeathCertificate =
    !inputs.isDeathVerified || inputs.selectedAccountTypes.includes(DocumentUploadAccountTypes.IRA);

  const needsLegalProse = inputs.selectedAccountTypes.some((type) =>
    ACCOUNT_TYPES_NEEDING_LEGAL_PROSE.includes(type),
  );

  const labels: ViadocExpectableLabel[] = [];
  if (needsDeathCertificate) {
    labels.push('death_certificate');
  }
  if (needsLegalProse) {
    labels.push('legal_prose');
  }

  return labels;
}

function resolveDocUploadLabels(inputs: ExpectedLabelInputs): ViadocExpectableLabel[] {
  if (inputs.isDivorceFlow) {
    return ['legal_prose'];
  }

  if (inputs.isMultiInheritanceFlow) {
    return inputs.isMultiInheritanceEstateToggleOn
      ? resolveMultiInheritanceEstateLabels(inputs)
      : ['death_certificate'];
  }

  const needsLegalProse =
    inputs.isTrustToTrustFlow ||
    inputs.isTrustee ||
    !!inputs.typeOfTrust ||
    inputs.isExecutor ||
    inputs.isIRAExecutor;

  if (needsLegalProse) {
    return inputs.isDeathVerified ? ['legal_prose'] : ['death_certificate', 'legal_prose'];
  }

  return ['death_certificate'];
}

export function resolveExpectedLabels(inputs: ExpectedLabelInputs): ViadocExpectableLabel[] {
  switch (inputs.uploadStep) {
    case 'l8_upload':
      return ['l8'];
    // Viadoc returns 'other' for PA ITW and letter of approval
    case 'itw_upload':
    case 'letter_upload':
      return ['other'];
    default:
      return resolveDocUploadLabels(inputs);
  }
}
